import { VaultDocumentDTO } from "../DTO/vaultDocumentDTO";

export class DeleteVaultDocumentRequest{
    public userId!:string;
    public businessId!:string;
    public vaultDocument!:VaultDocumentDTO;
}